import { render, staticRenderFns } from "./ConfirmDeleteCard.vue?vue&type=template&id=56cfbfcc"
import script from "./ConfirmDeleteCard.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports